<template>
  <base-section id="affiliates" class="grey lighten-4" space="36">
    <v-container>
      <base-section-heading :title="$t('sections.affiliates.header')" />

      <v-slide-group>
        <template v-for="(item, i) in itmes">
          <v-slide-item :key="i" class="align-self-center">
            <base-img
              class="logo"
              :src="require(`@/assets/trustUs/${item.logo}`)"
              :href="item.url"
              target="_blank"
              color="grey"
              contain
              :height="item.height || '40'"
              :width="item.width || '128'"
            />
          </v-slide-item>

          <v-responsive
            v-if="i < itmes.length -1 "
            :key="`divider-${i}`"
            class="text-center divider"
            height="70"
            width="48"
          >
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionAffiliates",
  data() {
    return {
      itmes: [
        {
          logo: "city_park.jpg",
          url: "#",
        },
        {
          logo: "skanska.jpg",
          url: "#",
        },
        {
          logo: "cdf.jpg",
          url: "#",
        },
        {
          logo: "angama.jpg",
          url: "#",
          height: 30
        },
        {
          logo: "idea_MM.jpg",
          url: "#",
        },
        {
          logo: "ars_medical.png",
          url: "#",
          height: 35
        },
        {
          logo: "agrobex.jpg",
          url: "#",
          height: 50
        },
        {
          logo: "chobienice.png",
          url: "#",
        },
        {
          logo: "CTS.jpg",
          url: "#",
        },
        {
          logo: "ecdf.jpg",
          url: "#",
          height: 50
        },
        {
          logo: "energika.jpg",
          url: "#",
          height: 35
        },
        {
          logo: "GPD.jpg",
          url: "#",
          height: 60
        },
        {
          logo: "moderno.jpg",
          url: "#",
        },
        {
          logo: "Pulva.jpg",
          url: "#",
          height: 80
        },
        {
          logo: "robakowski.jpg",
          url: "#",
          height: 100
        },
        {
          logo: "sommerrey.jpg",
          url: "#",
          height: 30,
          width: 180,
        },
        {
          logo: "strabag.jpg",
          url: "#",
          height: 30,
          width: 160
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.logo {
  cursor: pointer;
  filter: grayscale(1);
  transition: 100ms;
}
.logo:hover{
  filter: grayscale(0)
}
.divider{
  margin-top: 12px;
}
#affiliates{
  background-color: #fff !important;
}
</style>
